import { Alert, AlertButton, Platform } from "react-native";

/**
 * Alerte cross-platform.
 *
 * Sur natif (iOS/Android) : délègue à `Alert.alert` — comportement INCHANGÉ.
 * Sur web : `Alert.alert` de react-native-web est un no-op (rien ne s'affiche),
 * ce qui faisait disparaître silencieusement les messages d'erreur Supabase.
 * On retombe donc sur les dialogues natifs du navigateur (`window.alert` /
 * `window.confirm`) et on déclenche le bon `onPress`.
 *
 * Mapping web pour 2+ boutons :
 *   - OK (confirm)   → premier bouton non-"cancel"
 *   - Annuler        → bouton "cancel" (ou rien)
 */
export function showAlert(
  title: string,
  message?: string,
  buttons?: AlertButton[]
): void {
  if (Platform.OS !== "web") {
    Alert.alert(title, message, buttons);
    return;
  }

  const text = message ? `${title}\n\n${message}` : title;

  if (typeof window === "undefined") return;

  if (!buttons || buttons.length <= 1) {
    window.alert(text);
    buttons?.[0]?.onPress?.();
    return;
  }

  const confirmBtn = buttons.find((b) => b.style !== "cancel") ?? buttons[0];
  const cancelBtn = buttons.find((b) => b.style === "cancel");

  if (window.confirm(text)) {
    confirmBtn.onPress?.();
  } else {
    cancelBtn?.onPress?.();
  }
}
